var map = {
	"./defaultNoData.png": 6691,
	"./img_articlesicon.svg": 8070,
	"./img_frame.svg": 13,
	"./img_frame_1.svg": 1174,
	"./img_heartcircleve.svg": 397,
	"./img_image.png": 2455,
	"./img_loginicon.svg": 6694,
	"./img_settingsovr.svg": 9349,
	"./img_socialmediaic.svg": 4658,
	"./img_teamicon.svg": 9274,
	"./img_vector.svg": 6645,
	"./img_vector_1.svg": 1557,
	"./img_vector_2.svg": 577,
	"./img_vector_3.svg": 6139,
	"./img_vector_4.svg": 179,
	"./img_vector_5.svg": 2623,
	"./img_vector_6.svg": 2788,
	"./img_vector_7.svg": 2086,
	"./img_vector_8.svg": 2052,
	"./img_warningsign.svg": 136,
	"./img_whatsappimage.png": 6054,
	"./img_whatsappimage_1.png": 1241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;